import type { FilterDef } from "@/components/fw/data-table/types";
import type { StorefrontOrderDto } from "@/lib/storefront-api";

type OrderRow = StorefrontOrderDto;

export const orderFilters: FilterDef<OrderRow>[] = [
	{
		id: "OrderNumber",
		label: "Number",
		type: "text",
		field: "OrderNumber",
		operatorMode: { allow: ["=", "contains", "starts with"] },
	},
	{
		id: "OrderType",
		label: "Type",
		type: "text",
		field: "OrderType",
		operatorMode: { allow: ["=", "contains"] },
	},
	{
		id: "DealId",
		label: "Deal",
		type: "text",
		field: "DealId",
		operatorMode: { allow: ["="] },
	},
	{
		id: "Description",
		label: "Description",
		type: "text",
		field: "Description",
		operatorMode: { allow: ["contains", "=", "starts with"] },
	},
	{
		id: "EstimatedStart",
		label: "Start Date",
		type: "date",
		field: "EstimatedStart",
	},
	{
		id: "EstimatedStop",
		label: "Stop Date",
		type: "date",
		field: "EstimatedStop",
	},
	{
		id: "Warehouse",
		label: "Warehouse",
		type: "text",
		field: "Warehouse",
		operatorMode: { allow: ["=", "contains"] },
	},
	{
		id: "Status",
		label: "Status",
		type: "text",
		field: "Status",
		operatorMode: { allow: ["=", "contains"] },
	},
];
